<template>
  <div class="mt-5 mx-auto" style="max-width: 550px">
    <v-toolbar class="search-contain" style="border-radius: 20px; background: transparent !important">
      <v-autocomplete
        v-model="select"
        :items="filteredItems"
        item-text="text"
        return-object
        :search-input.sync="search"
        cache-items
        class="search-device mx-8"
        flat
        autofocus
        hide-no-data
        hide-details
        solo
        :label="$t('admin.menu.general_search')"
        @input="onSelect" />
    </v-toolbar>

    <ErrorDialog
      :isActive="errorDialog"
      v-bind:tittleText="$t('general.dialog.error.title')"
      :messageText="errorText"
      v-bind:acceptButtonText="$t('general.dialog.error.accept_button')"
      v-on:accept-dialog="errorDialog = false" />
  </div>
</template>

<script>
import ErrorDialog from '../../../components/errorDialog';
import router from '../../../plugins/router/index';

import { getUserDevicesForSearch } from '../../../server/petitions/users/getUserDevices';
import { getUser } from '../../../viewModels/userViewModel';
import { getAllUsers, getAllCompanies } from '../../../viewModels/adminViewModel';
import { getAllBeacons } from '../../../viewModels/adminViewModel';
import { getAllSims } from '../../../viewModels/adminViewModel';

export default {
  components: { ErrorDialog },

  data: () => ({
    search: '',
    select: null,

    devicesItems: [],
    usersItems: [],
    companiesItems: [],
    beaconsItems: [],
    simsItems: [],

    errorDialog: false,
    errorText: '',
  }),

  computed: {
    allItems() {
      return [...this.devicesItems, ...this.usersItems, ...this.companiesItems, ...this.beaconsItems, ...this.simsItems];
    },

    filteredItems() {
      if (!this.search) return this.allItems;
      const search = this.search.toLowerCase();
      return this.allItems.filter((item) => item.searchable.includes(search));
    },
  },

  methods: {
    onSelect(item) {
      if (!item) return;

      if (item.type === 'device') {
        router.push({
          name: 'editDevice',
          params: { device_sn: Number(item.value) },
        });
        this.select = null;
        return;
      }

      if (item.type === 'user') {
        router.push({
          name: 'editUser',
          params: { userId: item.value },
        });
        this.select = null;
        return;
      }

      if (item.type === 'company') {
        router.push({
          name: 'editCompany',
          params: { companyId: item.value },
        });
        this.select = null;
      }

      if (item.type === 'beacon') {
        router.push({
          name: 'editBeacon',
          params: { mac_address: item.value },
        });
        this.select = null;
      }

      if (item.type === 'sim') {
        router.push({
          name: 'simcards',
          query: {
            iccid: item.value.iccid,
          },
        });
        this.select = null;
      }
    },
  },

  mounted: async function () {
    try {
      const user = await getUser();
      const devices = await getUserDevicesForSearch(user.token, user.userId);
      this.devicesItems = devices.map((d) => ({
        type: 'device',
        text: `📟 ${d.alias} — ${d.device_sn}`,
        value: d.device_sn,
        searchable: [d.alias, d.device_sn, d.model].filter(Boolean).join(' ').toLowerCase(),
      }));

      const users = await getAllUsers();
      this.usersItems = users.map((u) => ({
        type: 'user',
        text: `👤 ${u.name} — ${u.email}`,
        value: u._id,
        searchable: [u.name, u.email, u.phone, u.company].filter(Boolean).join(' ').toLowerCase(),
      }));

      const companies = await getAllCompanies();
      this.companiesItems = companies.map((c) => ({
        type: 'company',
        text: `🏢 ${c.name} — ${c.cif}`,
        value: c._id,
        searchable: [c.name, c.email, c.phone, c.cif, c.notes].filter(Boolean).join(' ').toLowerCase(),
      }));

      const beacons = await getAllBeacons();
      this.beaconsItems = beacons.map((b) => ({
        type: 'beacon',
        text: `📡 ${b.alias || 'Sin alias'} — ${b.mac_address}`,
        value: b.mac_address,
        searchable: [b.alias, b.mac_address, b.category, ...(b.user_name || [])].filter(Boolean).join(' ').toLowerCase(),
      }));

      const sims = await getAllSims();

      this.simsItems = sims.map((s) => ({
        type: 'sim',
        text: `📶 ${s.iccid}${s.device_sn ? ' — SN ' + s.device_sn : ''}`,
        value: s,
        searchable: [s.iccid, s.device_sn, s.carrier, s.status, s.phone, s.notes].filter(Boolean).join(' ').toLowerCase(),
      }));
    } catch (e) {
      console.error(e);
      this.errorText = this.$t('general.error.unexpected_error');
      this.errorDialog = true;
    }
  },
};
</script>

<style>
.search-device {
  background: #f7f7f739;
}
</style>
